import React from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Typography,
    Box,
} from '@mui/material';
import { REPORT_TYPES } from '../constants';

const ReportTypeSelector = ({ value, onChange, showDeferredCost = true }) => {
    // EXT-LAUNCH-009: hide the Deferred Cost report from roles not permitted to see cost.
    const availableReportTypes = showDeferredCost
        ? REPORT_TYPES
        : REPORT_TYPES.filter((type) => type.id !== 'DEFERRED_COST');

    return (
        <FormControl fullWidth size="small">
            <Select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                displayEmpty
                renderValue={(selected) => {
                    if (!selected)
                        return <Typography color="text.secondary">Select Report Type</Typography>;
                    const type = REPORT_TYPES.find((t) => t.id === selected);
                    return type ? type.label : selected;
                }}
            >
                {availableReportTypes.map((type) => {
                    const IconComponent = type.icon;
                    return (
                        <MenuItem key={type.id} value={type.id}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                {IconComponent && (
                                    <ListItemIcon sx={{ minWidth: 'auto' }}>
                                        <IconComponent fontSize="small" />
                                    </ListItemIcon>
                                )}
                                <ListItemText
                                    primary={type.label}
                                    secondary={type.description}
                                    primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                                    secondaryTypographyProps={{ variant: 'caption' }}
                                />
                            </Box>
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

export default ReportTypeSelector;
